import { Delete } from "@mui/icons-material";
import { Edit } from "@mui/icons-material";
import PopupMenu from "../../../PopupMenu/PopupMenu";
import { PopupMenuProps } from "../../../PopupMenu/PopupMenu";

type TodoPopupMenuProps = {
    onEdit: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
    onDelete: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
} & Omit<PopupMenuProps, 'options'>

const TodoPopupMenu = ({ onEdit, onDelete, ...props }: TodoPopupMenuProps) => {
    return <PopupMenu {...props} options={[
        { icon: <Edit sx={{ color: 'text.secondary' }} />, label: 'Edit', onClick: onEdit },
        { icon: <Delete sx={{ color: 'text.secondary' }} />, label: 'Delete', onClick: onDelete },
    ]} />
}

export default TodoPopupMenu;  